export const checkLength =
  (minLength: number, maxLength: number) =>
  (value: string): boolean =>
    value.length >= minLength && value.length <= maxLength;

const UPPER_CASE_REGEX = /[A-Z]/;
export const containUpperCase = (value: string): boolean =>
  UPPER_CASE_REGEX.test(value);

const LOWER_CASE_REGEX = /[a-z]/;
export const containLowerCase = (value: string): boolean =>
  LOWER_CASE_REGEX.test(value);

const NUMBER_REGEX = /[0-9]/;
export const containNumber = (value: string): boolean =>
  NUMBER_REGEX.test(value);

// https://developer.mozilla.org/ja/docs/Web/JavaScript/Guide/Regular_Expressions
function escapeRegExp(string: string) {
  // eslint-disable-next-line no-useless-escape
  return string.replace(/[.*+?^=!:${}()|[\]\/\\]/g, '\\$&'); // $&はマッチした部分文字列全体を意味します
}

const SYMBOLS = [
  '=',
  '+',
  '-',
  '/',
  '%',
  '@',
  '(',
  ')',
  '{',
  '}',
  '<',
  '>',
  '[',
  ']',
  ';',
  ':',
  ',',
  '.',
  '"',
  "'",
  '`',
  '^',
  '~',
  '_',
  '!',
  '#',
  '$',
  '&',
  '?',
  '|',
  '\\',
  '*',
] as const;

const symbolRegex = new RegExp(SYMBOLS.map((s) => escapeRegExp(s)).join('|'));
export const containSymbol = (value: string): boolean =>
  symbolRegex.test(value);
